import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './permissions.styles'
import Section from '../../../shared/section/section'
import Segment from '../../../shared/segment/segment'
import Segments from '../../../shared/segments/segments'
import Child from './children/child/child.container'
import { Table, HeadCell } from 'pobble-components/dist/table'
import Tooltip from 'pobble-components/dist/tooltip'
import InfoIcon from 'react-icons/lib/fa/info-circle'
import Button from 'pobble-components/dist/button'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import Autocomplete from 'react-autocomplete'
import classNames from 'classnames'
import { Formik } from 'formik'
import * as Yup from 'yup'

class Permission extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
      schools: [],
      isModalOpen: false
    }
  }

  getSchools(value, cb) {
    this.props
      .onSearchChange(value)
      .then(({ data }) => this.setState({ schools: data.schools }))
  }

  componentDidMount() {
    this.props.onMount()
  }

  setConnectModal(bool) {
    this.setState({ isModalOpen: bool })
  }

  render() {
    const { classes, pending, children, onSubmit } = this.props
    return (
      !pending && (
        <Section
          title="Parental access"
          pending={pending}
          renderHeader={() => (
            <Button tall secondary action={() => this.setConnectModal(true)}>
              Connect my account
            </Button>
          )}>
          <Segments>
            <Segment size={'L'} className={classes.table}>
              <p>
                Connect to your child’s Pobble account to see writing published
                by your child.
              </p>
              {!!children.length && (
                <Table>
                  <thead>
                    <tr>
                      <HeadCell className={classes.left}>
                        Your children
                      </HeadCell>
                      <HeadCell />
                    </tr>
                  </thead>
                  <tbody>
                    {children.map(child => (
                      <Child
                        key={child.student_type.account.id}
                        id={child.student_type.account.id}
                      />
                    ))}
                  </tbody>
                </Table>
              )}
            </Segment>
          </Segments>
          <Modal
            isOpen={this.state.isModalOpen}
            closeButton
            requestClose={() => this.setConnectModal(false)}>
            <Formik
              onSubmit={values =>
                onSubmit(values).then(this.setConnectModal(false))
              }
              validationSchema={Yup.object().shape({
                parentCode: Yup.string().required(
                  'This field should not be empty'
                )
              })}
              initialValues={{
                schoolId: null,
                parentCode: ''
              }}>
              {formikProps => {
                const {
                  values,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                  touched,
                  errors
                } = formikProps
                return (
                  <form onSubmit={handleSubmit}>
                    <ModalHeader>Connect to my child’s account</ModalHeader>
                    <ModalContent className={classes.modalContent}>
                      <div>
                        <FormLabel>Select your child's school:</FormLabel>
                        <Autocomplete
                          inputProps={{
                            id: 'schools-autocomplete',
                            className: classes.field,
                            placeholder: 'Ex: Holywell Primary School'
                          }}
                          wrapperStyle={{ position: 'relative' }}
                          value={this.state.value}
                          items={this.state.schools}
                          getItemValue={item => item.title}
                          onSelect={(value, item) => {
                            this.setState({
                              value,
                              schools: [item],
                              selectedSchool: item
                            })
                            setFieldValue('schoolId', item.id)
                          }}
                          onChange={(event, value) => {
                            this.setState({ value, selectedSchool: null })
                            this.getSchools(value)
                            setFieldValue('schoolId', null)
                          }}
                          renderMenu={children => (
                            <div className={classes.menu}>{children}</div>
                          )}
                          renderItem={(item, isHighlighted) => (
                            <div
                              className={classNames(classes.item, {
                                [classes.highlighted]: isHighlighted
                              })}
                              key={item.id}>
                              {`${item.title}${
                                item.city
                                  ? ' (' +
                                    item.city +
                                    (item.postcode
                                      ? ', ' + item.postcode
                                      : '') +
                                    ')'
                                  : ''
                              }`}
                            </div>
                          )}
                        />
                      </div>
                      <div>
                        <FormLabel htmlFor="parentCode">
                          Enter your Parent/Carer code{' '}
                          <Tooltip
                            content={
                              'Please contact your child’s teacher if you haven’t received your parent/carer code. '
                            }>
                            <InfoIcon className={classes.info} />
                          </Tooltip>
                          :
                        </FormLabel>
                        <FormInput
                          name="parentCode"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.parentCode}
                          placeholder={'Ex: ABCDEFGHIJKL'}
                          validationError={
                            touched.parentCode && errors.parentCode
                          }
                          disabled={!values.schoolId}
                        />
                      </div>
                    </ModalContent>
                    <ModalFooter alignRight>
                      <Button pending={pending} type="submit" tall>
                        {!pending && 'Connect'}
                        {pending && 'Connecting...'}
                      </Button>
                    </ModalFooter>
                  </form>
                )
              }}
            </Formik>
          </Modal>
        </Section>
      )
    )
  }
}

export default injectSheet(styles)(Permission)
